import { useCallback, useEffect, useRef, useState } from 'react';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ToastState {
  text: string;
  action?: ToastAction;
}

/** Eén zichtbare melding tegelijk; een nieuwe melding vervangt de vorige en de timer wordt netjes opgeruimd. */
export function useToast() {
  const [toast, setToast] = useState<ToastState | null>(null);
  const timer = useRef<number | undefined>(undefined);

  const showToast = useCallback((text: string, durationMs = 3000, action?: ToastAction) => {
    window.clearTimeout(timer.current);
    setToast({ text, action });
    timer.current = window.setTimeout(() => setToast(null), durationMs);
  }, []);

  const dismissToast = useCallback(() => {
    window.clearTimeout(timer.current);
    setToast(null);
  }, []);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  return { toast, toastMessage: toast?.text ?? null, showToast, dismissToast };
}
